export default function handleFormSubmitOnChange() {
  console.log('handleFormSubmitOnChange');
  const selectors = "[data-submit-form] select, [data-submit-form] input[type='radio'], select[data-submit-form]";
  const formElements = document.querySelectorAll(selectors);

  formElements.forEach((element) => {
    // prevent binding twice
    if (element.dataset.submitFormBound === "true") return;
    element.dataset.submitFormBound = "true";

    element.addEventListener("change", function () {
      const form = this.closest("form");
      if (form) form.requestSubmit();
    });
  });
}